import { render, staticRenderFns } from "./Notificaciones_magypago.vue?vue&type=template&id=4dbb8df6&"
import script from "./Notificaciones_magypago.vue?vue&type=script&lang=js&"
export * from "./Notificaciones_magypago.vue?vue&type=script&lang=js&"
import style0 from "./Notificaciones_magypago.vue?vue&type=style&index=0&id=4dbb8df6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports